import { headerColors } from "./chart-options-config";
import { deepCopy } from "../../app/util";
/**
 * Function to add SellRate measure data points for each unique identifier
 * Adds the new datapoints directly to the existing array
 * @param {Array} existingData - The existing data array (like exampledata)
 * @returns {Array} - A single flat array with all datapoints: original ones plus the new SellRate datapoints
 */
export function addSellRateDataPoints(existingData, segmented_view,segmentedIdentifiers,measures,measureR, dayOfWeek) {
  // Create a new array to hold all datapoints (original + new)
  const resultArray = deepCopy(existingData); // Start with all existing datapoints
   const numSegments = segmentedIdentifiers.length;
  // Find unique identifiers

  // Calculate the number of measures that are not null
  const measuresLength = measures.filter(measure => measure !== null).length;
  const uniqueIdentifiers = [...new Set(existingData.map(item => item.identifier))];
  let colorsArray = deepCopy(headerColors.bi_sensitivity_colors);
  let last = colorsArray.pop();
  colorsArray.unshift(last);
  // For each unique identifier, create a new data point with measure="SellRate"
  let colorIndex = colorsArray.length - 1;
  uniqueIdentifiers.forEach((identifier, identifierIndex) => {
    // Find an existing data point with this identifier to use as a template
    const template = existingData.find(item => item.identifier === identifier);
    console.log("identifierIndex", identifierIndex, identifier);
    // Create a new index for this identifier
    const existingItems = existingData.filter(item => item.identifier === identifier);
    const newIndex = existingItems.length;
 
    // Create the new data point based on the template
    const newDataPoint = {
      // Copy the template data
      ...deepCopy(template),
      
      // Update the specific fields that need to change
      "name":`BI_SENSITIVITY_ANALYSIS_SELLRATE_${identifier}`,
      "currency":{
         ...template.currency
      },
      "boostThreshold": 100,
      "dataGrouping":{
         "units":[
            [
               "day",
               [
                  1
               ]
            ]
         ],
         "enabled":false
      },
      "negativeColor":"#FF0000",
      "category":"Bi_sensitivity_analysis",
      "seriesName":`BI_SENSITIVITY_ANALYSIS_SELLRATE_${identifier}`,
      "subCategory":"",
      "tooltipLabel":`BI_SENSITIVITY_ANALYSIS_SELLRATE_${identifier}`,
      "tile":"bi_sensitivity_analysis",
      "identifier":identifier,
      "identifierIndex":3,
      "marker":{
         "enabled":false
      },
      id: `BI_SENSITIVITY_ANALYSIS_SELLRATE_${identifier}_${identifierIndex}`,
      type: "spline", // Use spline chart type like the RevPAR measure
      yAxis: "secondaryRightYAxis"+measureR, // Create a new axis for SellRate
      mainMeasure: "SellRate",
      color: colorsArray[identifierIndex], // Use a different color for SellRate
      legendLabel: `SellRate ${identifier.split('_')[2]}`, // Format legend label like the others
      measure: "SellRate",
      measureIndex: newIndex,
      segmentName: "total",
      visible: true,
      showInLegend: true,
      zIndex: 3, // Increment zIndex from the others
      colorKey: `${template.mapings.general}_SELLRATE_R`,
      mainCKey: `${template.mainCKey.split('_')[0]}_${template.mainCKey.split('_')[1]}_R`
    };
    if(dayOfWeek === 'mon,tue,wed,thu,fri,sat,sun'
      || dayOfWeek === 'mon,tue,wed,thu' ||
      dayOfWeek === 'fri,sat,sun') {
         newDataPoint.legendLabel = "SellRate " + identifier.split('_')[2] + " - " + identifier.split('_')[3]
      } else {
         newDataPoint.legendLabel = "SellRate " + identifier.split('_')[3]
      }
    // Update the mapping properties
    newDataPoint.mapings = {
      column: "BI_SENSITIVITY_ANALYSIS_SELLRATE",
      general: template.mapings.general,
      specific: `${template.mapings.general}_SELLRATE`
    };
    
    // Update the data points for SellRate - Fix for the tooltip issue
    newDataPoint.data = template.data.map(point => {
      // Create a new specialized allKpis object for SellRate
      const specializedAllKpis = {
        SellRate: isNaN(point.allKpis.SellRate) ? null : parseInt(point.allKpis.SellRate),
        // Create separate copies of other KPIs to avoid reference issues
        Rooms: point.allKpis.Rooms || null,
        Revenue: point.allKpis.Revenue || null,
        ADR: point.allKpis.ADR || null,
        RevPAR: point.allKpis.RevPAR || null,
        Occ: point.allKpis.Occ || null
      };
     
      const result = {
        x: point.x,
        y: specializedAllKpis.SellRate,
        y2: specializedAllKpis.SellRate,
        allKpis: specializedAllKpis
      };
      
      return result;
    });
    
    // Add the new data point directly to our result array
    // Insert the new data point at position 2 for first identifier, or after every group of 3 for others
    if(!segmented_view){
      let insertPosition = 0;
      if(identifierIndex === 0){
        // For first identifier, insert at position 1
        insertPosition = measuresLength === 1 ? 1 : 2;
      } else {
        // For subsequent identifiers, insert right after their corresponding original datapoint
        insertPosition = identifierIndex * (measuresLength + 1) + measuresLength;
      }
      
      // Ensure insert position doesn't exceed array length
      if (insertPosition > resultArray.length) {
        // If calculated position is beyond array length, just append to the end
        resultArray.push(newDataPoint);
      } else {
        resultArray.splice(insertPosition, 0, newDataPoint);
      }
    } else {
      // For segmented view, we need to calculate the insertion position based on:
      // 1. Number of segments (segmentedIdentifiers.length)
      // 2. Number of measures (measuresLength)
      // 3. Current identifier index (identifierIndex)
      
      
      // Calculate the position to insert the SellRate data point
      // For each segment, we have measuresLength data points
      // So we need to insert after every (numSegments * measuresLength) points
      // Plus the current identifier's position
      
      const segmentOffset = identifierIndex * numSegments * measuresLength;
      const measureOffset = measuresLength * (identifierIndex + 1);
      const insertPosition = segmentOffset + measureOffset;
      
      // Use the headerColors.bi_sensitivity_colors array for consistent coloring
      
      resultArray.splice(insertPosition, 0, newDataPoint);
    }
    colorIndex--;
  });
  
  // Return the combined array with all datapoints
  return resultArray;
}

// Example usage:
// const combinedData = addSellRateDataPoints(exampledata);
// This will produce an array like:
// [
//   {identifier:"primary_range_2024-04-23_2024-04-23", measure:"Occ", ...},
//   {identifier:"primary_range_2024-04-23_2024-04-23", measure:"RevPAR", ...},
//   {identifier:"primary_range_2024-04-23_2024-04-23", measure:"SellRate", ...}
// ]